import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_stock_adjustment_import_file_hdr_RowClass} from '../../../dbschema'

export class StockAdjustmentImportFileContainerModel extends BaseContainerModel {
  bl_inv_stock_adjustment_import_file_hdr: bl_inv_stock_adjustment_import_file_hdr_RowClass = new bl_inv_stock_adjustment_import_file_hdr_RowClass();
}




